import React from 'react';

interface TitleBlockProps {
  titleFr: string;
  titleEn: string;
  frColor?: string;
  enColor?: string;
  frWeight?: 'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold';
  enWeight?: 'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold';
  frSize?: string;
  enSize?: string;
  frLineHeight?: string;
  enLineHeight?: string;
}

function TitleBlock({
  titleFr,
  titleEn,
  frColor = '#003DA5',
  enColor = '#00AEEF',
  frWeight = 'extrabold',
  enWeight = 'extrabold',
  frSize = '6vw',
  enSize = '4.5vw',
  frLineHeight = '1.2',
  enLineHeight = '1',
}: TitleBlockProps) {
  const getFontWeightClass = (weight: string) => {
    const weightMap: { [key: string]: string } = {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
      extrabold: 'font-extrabold',
    };
    return weightMap[weight] || 'font-extrabold';
  };

  return (
    <div className="mb-[1vh] flex justify-between">
      <div className="flex flex-col">
        <h2
          className={`mb-[0.5vh] ${getFontWeightClass(frWeight)}`}
          style={{ color: frColor, fontSize: frSize, lineHeight: frLineHeight }}
        >
          {titleFr}
        </h2>
        <p
          className={`${getFontWeightClass(enWeight)}`}
          style={{ color: enColor, fontSize: enSize, lineHeight: enLineHeight }}
        >
          {titleEn}
        </p>
      </div>
    </div>
  );
}

export default TitleBlock;
